<template>
  <CommonHeader class="main_head_block">
      <template v-slot:header>
          <span class="module_heading">{{ $route.params.campaignId ? "Edit" : "Add New" }} Campaign</span>
      </template>   
  </CommonHeader>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
export default {
  components: { CommonHeader }
};
</script>

<style lang="scss"></style>
